<template>
  <v-row class="my-6" no-gutters>
    <v-col cols="12">
      <v-row align="stretch">
        <v-col cols="7" class="py-0">
          <v-card class="pa-4">
            <v-row no-gutters>
              <v-col>
                <div v-if="hasHeaderImg">
                  <img :src="campaign.message.simple_email_configuration.header_image" class="responsive-image" />
                  <div class="d-flex justify-end mt-1">
                    <download-file-button :url="campaign.message.simple_email_configuration.header_image" />
                  </div>
                </div>
                <v-row v-else class="background-img-header" align="center" no-gutters>
                  <v-col class="img-text text-center">
                    <mf-icon size="60">image</mf-icon>
                    <p class="primary-text">Insira uma imagem</p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters justify="center" class="mt-3">
              <v-col cols="12">
                <v-row>
                  <v-col>
                    <span
                      v-for="(msg, index) of splittedText(campaign.message.simple_email_configuration.subject, 'Seu título vem aqui')"
                      :key="index"
                      class="email-marketing-card-title"
                      v-html="getEmailRevisedText(msg)"
                    />
                    <p
                      v-for="(msg, index) of splittedText(campaign.message.simple_email_configuration.text || 'O corpo do seu texto vem aqui.')"
                      :key="`${index}-${msg}`"
                      class="primary-text mb-0"
                      v-html="getEmailRevisedText(msg)"
                    />
                    <div v-if="hasBodyImg">
                      <img v-if="hasBodyImg" :src="campaign.message.simple_email_configuration.image" class="responsive-image" />
                      <div class="d-flex justify-end mt-1">
                        <download-image-button :url="campaign.message.simple_email_configuration.image" />
                      </div>
                    </div>
                    <v-row v-else class="background-img-content" align="center" no-gutters>
                      <v-col class="img-text text-center">
                        <mf-icon size="60">image</mf-icon>
                        <p class="primary-text">Insira uma imagem</p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row justify="center" class="my-3">
                  <v-col cols="12" class="d-flex justify-center">
                    <mf-button
                      :disabled="disabled"
                      block
                      size="lg"
                      color="cinza-l10"
                      :label="campaign.message.simple_email_configuration.click_to_call_button_text || 'O texto do seu botão vem aqui'"
                      @click="$emit('go-to-link')"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row no-gutters justify="center" class="email-footer">
              <v-col cols="11" class="pa-5">
                <span>{{ campaign.message.simple_email_configuration.footer || 'Seu texto do rodapé vem aqui' }}</span>
                <br />
                <span>Para se descadastrar da lista de e-mail, <a href="#">clique aqui</a></span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="5" class="py-0">
          <v-card height="100%">
            <v-divider class="my-2" />
            <v-col class="pa-4">
              <p class="email-marketing-card-title">Imagem para o cabeçalho</p>
              <p class="primary-text">
                Selecione uma imagem que seja condizente com a identidade do seu negócio ou da sua promoção. Essa imagem será a “cara” do seu e-mail.
              </p>
              <v-tooltip top :disabled="disableTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <mf-image-cropper
                      :mb-size-limit="10"
                      :disabled="disabled"
                      :upload-image="uploadHeaderImage"
                      :error-message="hasErrorImgHeader ? errorImgHeader : ''"
                      :url="headerImageUrl"
                      :width="600"
                      :height="200"
                      show-hint
                      @remove-image="deleteHeaderImage"
                      @snackbar="showSnackbar"
                    />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>
            </v-col>
            <v-divider class="my-2" />
            <v-col class="pa-4">
              <v-layout>
                <p class="email-marketing-card-title">Corpo do e-mail</p>
                <v-spacer />
                <div class="pr-3">
                  <message-variables channel="email" />
                </div>
                <template-message-modal v-model="selectedMessage" :disabled="disabled" :mode="['EMAIL']" />
              </v-layout>

              <v-tooltip top :disabled="disableTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <mf-textarea-emoji
                      v-model="campaign.message.simple_email_configuration.subject"
                      hide-details
                      class="textarea"
                      outlined
                      no-resize
                      rows="2"
                      :max-length="50"
                      :error-messages="errorEmailTitle"
                      placeholder="Título"
                      :disabled="disabled"
                    />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>

              <v-tooltip top :disabled="disableTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <mf-textarea-emoji
                      v-model="campaign.message.simple_email_configuration.text"
                      hide-details
                      class="textarea"
                      placeholder="Texto do corpo"
                      outlined
                      no-resize
                      rows="4"
                      :max-length="2000"
                      :error-messages="errorEmailContent"
                      :disabled="disabled"
                    />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>

              <p class="primary-text">Selecione uma imagem que irá compor o corpo do seu e-mail.</p>
              <v-tooltip top :disabled="disableTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <mf-image-cropper
                      :mb-size-limit="10"
                      :disabled="disabled"
                      :upload-image="uploadBodyImage"
                      :error-message="hasErrorImgBody ? errorImgBody : ''"
                      :url="bodyImageUrl"
                      :width="2000"
                      :height="2000"
                      show-hint
                      @remove-image="deleteBodyImage"
                      @snackbar="showSnackbar"
                    />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>
            </v-col>
            <v-divider class="my-2" />
            <v-col class="pa-4">
              <p class="email-marketing-card-title">Botão de chamada</p>
              <v-tooltip top :disabled="disableTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <mf-textarea-emoji
                      v-model="campaign.message.simple_email_configuration.click_to_call_button_text"
                      hide-details
                      class="textarea"
                      placeholder="Texto do botão"
                      outlined
                      no-resize
                      rows="2"
                      :max-length="20"
                      :error-messages="errorEmailBtnText"
                      :disabled="disabled"
                      avoid-variables
                    />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>
              <v-tooltip top :disabled="disableTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-textarea
                      v-model="campaign.message.simple_email_configuration.click_to_call_button_link"
                      class="textarea"
                      placeholder="Link do botão"
                      outlined
                      no-resize
                      rows="2"
                      :error-messages="errorEmailBtnLink"
                      :disabled="disabled"
                    />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>
            </v-col>
            <v-divider class="my-2" />
            <v-col class="pa-4">
              <p class="email-marketing-card-title">Rodapé</p>

              <v-tooltip top :disabled="disableTooltip">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <mf-textarea-emoji
                      v-model="campaign.message.simple_email_configuration.footer"
                      hide-details
                      class="textarea"
                      outlined
                      no-resize
                      rows="3"
                      :max-length="250"
                      :error-messages="errorEmailFooter"
                      :disabled="disabled"
                      avoid-variables
                    />
                  </div>
                </template>
                <span v-if="isMariaCampaignActivated || isMariaCampaignFinished">{{ disabledFieldTooltip }}</span>
                <span v-else>Habilite este canal pela caixa de seleção acima para configurá-lo.</span>
              </v-tooltip>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { textVariables } from '@/mixins/text-variables'
import isEmpty from 'lodash/isEmpty'

import BaseMJML from '@/modules/campanhas/campanhas-email/assets/simple_email.js'
import mjml2html from 'mjml-browser'
import TemplateMessageModal from '@/components/template-message/TemplateMessageModal'
import DownloadFileButton from '@/components/DownloadFileButton.vue'

const PROCESSED_HTML = mjml2html(BaseMJML, { minify: true }).html

export default {
  name: 'EmailConfiguration',
  components: {
    TemplateMessageModal,
    DownloadFileButton,
    MessageVariables: () => import('@/modules/campanhas/views/components/edit/MessageVariables.vue'),
  },
  mixins: [textVariables],
  props: {
    hasHeaderImg: {
      type: Boolean,
      default: false,
    },
    hasBodyImg: {
      type: Boolean,
      default: false,
    },
    tryingToSaveAsDraft: {
      type: Boolean,
      default: false,
    },
    isMariaCampaign: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignActivated: {
      type: Boolean,
      default: false,
    },
    isMariaCampaignFinished: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: Object,
      default: () => {},
    },
    validations: {
      type: Object,
      default: () => {},
    },
    headerImageUrl: {
      type: String,
      default: '',
    },
    deleteHeaderImage: {
      type: Function,
      default: () => {},
    },
    uploadHeaderImage: {
      type: Function,
      default: () => {},
    },
    bodyImageUrl: {
      type: String,
      default: '',
    },
    deleteBodyImage: {
      type: Function,
      default: () => {},
    },
    uploadBodyImage: {
      type: Function,
      default: () => {},
    },
  },
  data: () => ({
    selectedMessage: {},
  }),
  computed: {
    previewHTML() {
      const formatter = {
        text: this.campaign.message.simple_email_configuration.text,
        click_to_call_button_link: this.campaign.message.simple_email_configuration.click_to_call_button_link,
        click_to_call_button_text: this.campaign.message.simple_email_configuration.click_to_call_button_text,
        footer: this.campaign.message.simple_email_configuration.footer,
        header_image: this.campaign.message.simple_email_configuration.header_image,
        image: this.campaign.message.simple_email_configuration.image,
        subject: this.campaign.message.simple_email_configuration.subject,
      }
      let processedHTML = PROCESSED_HTML
      Object.entries(formatter).forEach(([key, value]) => {
        processedHTML = processedHTML.replaceAll(`{${key}}`, value)
      })
      return processedHTML
    },
    disableTooltip() {
      if (!this.isMariaCampaign) return true
      return !this.disabled
    },
    disabledFieldTooltip() {
      const status = this.isMariaCampaignFinished ? 'concluída' : 'ativa'
      return `Não é possível alterar essa configuração em uma campanha ${status}.`
    },
    hasErrorImgHeader() {
      if (!this.isMariaCampaign) return !this.tryingToSaveAsDraft && this.validations.campaign.message.simple_email_configuration?.header_image?.$error
      if (this.validations.campaign?.shotConfiguration?.email) {
        return !this.tryingToSaveAsDraft && this.validations.campaign.shotConfiguration.email.message.simple_email_configuration?.header_image.$error
      } else return false
    },
    hasErrorImgBody() {
      if (!this.isMariaCampaign) return !this.tryingToSaveAsDraft && this.validations.campaign.message.simple_email_configuration?.image?.$error
      if (this.validations.campaign?.shotConfiguration?.email) {
        return !this.tryingToSaveAsDraft && this.validations.campaign.shotConfiguration.email.message.simple_email_configuration?.image.$error
      } else return false
    },
    errorImgHeader() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message.simple_email_configuration
      if (this.validations.campaign?.shotConfiguration?.email)
        validations = this.validations.campaign.shotConfiguration.email.message.simple_email_configuration

      if (!validations || !validations.header_image) return ''
      if (validations.header_image.$error) {
        if (!validations.header_image.required) return 'Adicione uma imagem de cabeçalho.'
      }
      return ''
    },
    errorEmailTitle() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message?.simple_email_configuration
      if (this.validations.campaign?.shotConfiguration?.email)
        validations = this.validations.campaign.shotConfiguration.email.message.simple_email_configuration

      if (!validations || !validations.subject) return ''
      if (validations.subject.$error) {
        if (!validations.subject.required) return 'Adicione um título ao e-mail.'
        else if (!validations.subject.maxLength) return 'O título do e-mail excedeu 50 caracteres.'
        else if (!validations.subject.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorEmailContent() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message?.simple_email_configuration
      if (this.validations.campaign?.shotConfiguration?.email)
        validations = this.validations.campaign.shotConfiguration.email.message.simple_email_configuration

      if (!validations || !validations.text) return ''
      if (validations.text.$error) {
        if (!validations.text.required) return 'Adicione o texto do corpo do e-mail.'
        else if (!validations.text.maxLength) return 'O texto do corpo do e-mail excedeu 2000 caracteres.'
        else if (!validations.text.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorEmailBtnText() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message?.simple_email_configuration
      if (this.validations.campaign?.shotConfiguration?.email)
        validations = this.validations.campaign.shotConfiguration.email.message.simple_email_configuration

      if (!validations || !validations.click_to_call_button_text) return ''
      if (validations.click_to_call_button_text.$error) {
        if (!validations.click_to_call_button_text.required) return 'Adicione um texto para o botão de chamada.'
        else if (!validations.click_to_call_button_text.maxLength) return 'O texto do botão de chamada excedeu 20 caracteres.'
        else if (!validations.click_to_call_button_text.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorEmailBtnLink() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message?.simple_email_configuration
      if (this.validations.campaign?.shotConfiguration?.email)
        validations = this.validations.campaign.shotConfiguration.email.message.simple_email_configuration

      if (!validations || !validations.click_to_call_button_link) return ''
      if (validations.click_to_call_button_link.$error) {
        if (!validations.click_to_call_button_link.required) return 'Adicione um link para o botão de chamada.'
        else if (!validations.click_to_call_button_link.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
        else if (!validations.click_to_call_button_link.isUrl) return 'Apenas links são permitidos nesse campo.'
      }
      return ''
    },
    errorEmailFooter() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message?.simple_email_configuration
      if (this.validations.campaign?.shotConfiguration?.email)
        validations = this.validations.campaign.shotConfiguration.email.message.simple_email_configuration

      if (!validations || !validations.footer) return ''
      if (validations.footer.$error) {
        if (!validations.footer.required) return 'Adicione um rodapé para este e-mail.'
        else if (!validations.footer.maxLength) return 'O rodapé do e-mail excedeu 250 caracteres.'
        else if (!validations.footer.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorImgBody() {
      let validations = null
      if (!this.isMariaCampaign) validations = this.validations.campaign.message?.simple_email_configuration
      if (this.validations.campaign?.shotConfiguration?.email)
        validations = this.validations.campaign.shotConfiguration.email.message.simple_email_configuration

      if (!validations || !validations.image) return ''
      if (validations.image.$error) {
        if (!validations.image.required) return 'Adicione uma imagem de corpo.'
      }
      return ''
    },
  },
  watch: {
    selectedMessage() {
      if (!this.isMariaCampaign) this.campaign.message.simple_email_configuration.text = this.selectedMessage.message
      if (this.validations.campaign?.shotConfiguration?.email) this.campaign.message.simple_email_configuration.text = this.selectedMessage.message
    },
    'campaign.message.simple_email_configuration': {
      handler() {
        this.campaign.message.processed_html = this.previewHTML
      },
      deep: true,
    },
  },
  mounted() {
    this.campaign.message.processed_html = this.previewHTML
    if (isEmpty(this.campaign.message.simple_email_configuration)) {
      this.campaign.message.simple_email_configuration = {
        header_image: '',
        subject: '',
        text: '',
        image: '',
        click_to_call_button_text: '',
        footer: '',
      }
    }
  },
  methods: {
    showSnackbar(snackbar) {
      this.$snackbar(snackbar)
    },
    splittedText(text, defaultText) {
      if (!text) return defaultText.split('\n')
      return text.split('\n')
    },
    getEmailRevisedText(text) {
      return `${this.getRevisedText(text)}<br />`
    },
    getConfiguration() {
      return {}
    },
    isTouched() {
      return Boolean(
        this.campaign.message.simple_email_configuration.header_image ||
          this.campaign.message.simple_email_configuration.subject ||
          this.campaign.message.simple_email_configuration.text ||
          this.campaign.message.simple_email_configuration.image ||
          this.campaign.message.simple_email_configuration.click_to_call_button_text ||
          this.campaign.message.simple_email_configuration.footer
      )
    },
  },
}
</script>

<style lang="scss">
.email-marketing-card-title {
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.33px;
  color: $cinza-d20;
}
</style>
